var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"common_collect",class:{ active: _vm.active },style:({'height': (_vm.height + "px"), 'width': (_vm.width + "px")})})}
var staticRenderFns = []

export { render, staticRenderFns }